/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { PanelBody, ToggleControl, TextControl } from '@wordpress/components';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return { Element} Element to render.
 */
export default function Edit( { attributes, setAttributes } ) {

	const { showBaselineStatus, featureID } = attributes;

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'baseline-status' ) }>

					<ToggleControl
						checked={ !! showBaselineStatus }
						label={ __(
						'Show Baseline Status',
						'baseline-status'
						) }
						onChange={ ( value ) =>
							setAttributes( {
								showBaselineStatus: value,
							} )
						}
					/>
					{ showBaselineStatus && (
						<TextControl
							label={ __(
								'Feature',
								'baseline-status'
							) }
							value={ featureID || '' }
							onChange={ ( value ) =>
								setAttributes( { featureID: value } )
							}
						/>
					) }
				</PanelBody>
			</InspectorControls>

			<baseline-status { ...useBlockProps() } featureId={ featureID }></baseline-status>
		</>
	);
}
